/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { portfolio_ParentPortfolioEntryDomainDTO } from './portfolio_ParentPortfolioEntryDomainDTO';
import type { portfolio_ParentPortfolioEntryRatingDTO } from './portfolio_ParentPortfolioEntryRatingDTO';
import type { portfolio_ParentPortfolioEntrySubjectDTO } from './portfolio_ParentPortfolioEntrySubjectDTO';
export type portfolio_ParentPortfolioEntryDTO = {
    body?: string;
    childId?: string;
    domains?: Array<portfolio_ParentPortfolioEntryDomainDTO>;
    id?: string;
    observedAt?: string;
    ratings?: Array<portfolio_ParentPortfolioEntryRatingDTO>;
    releasedAt?: string;
    status?: portfolio_ParentPortfolioEntryDTO.status;
    subjects?: Array<portfolio_ParentPortfolioEntrySubjectDTO>;
    title?: string;
};
export namespace portfolio_ParentPortfolioEntryDTO {
    export enum status {
        DOCUMENTED = 'documented',
    }
}

